export const SEND_FEEDBACK = 'SEND_FEEDBACK'
export const SEND_FEEDBACK_ERROR = 'SEND_FEEDBACK_ERROR'
export const SEND_FEEDBACK_START_OVER = 'SEND_FEEDBACK_START_OVER'
